<template>
  <div class="modal fade vue-modal bd-example-modal-sm" :class="isShow?'show ':''" tabindex="-1" :style="isShow?'display:block;':'display:none;'">
    <div class="modal-mask" @click.self="close">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="modal_text text-center">您已是走走會員囉</p>
            <div class="modal_bottom">
              <div class="modal_btn_wrapper row justify-content-center">
                <div class="col-8">
                  <button class="btn primary md" @click="btnClick">
                    <span class="btn_text">立即登入</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {inject, ref} from "vue";

export default {
  name: "showLoginAfterOK",
  setup() {
    const isShow = ref(false);
    const open = () => {
      document.body.classList.add('modal-open');
      isShow.value = true
    };
    const close = () => {
      document.body.classList.remove('modal-open');
      isShow.value = false;
    };
    const showLogin = inject('showLogin');

    const btnClick = () => {
      showLogin();
      close();
    };

    return { isShow, open, close, btnClick };
  },
}
</script>